import React, { useState } from 'react';

import {
  OuterContainer,
  ContainerHeading,
  RecruitmentStagesContainer,
  IntegrationFieldLabel,
  TextInput,
  ErrorMessage,
} from './styles';
import { Button } from 'components/Button/RoundButton';

export default React.memo(({ candidateRatingWeight, updateCandidateRatingWeight, id, isSuperadmin }) => {
  const [ratingWeight, setRatingWeight] = useState(candidateRatingWeight || {});
  const [formError, setFormError] = useState('');

  const updateRatingWeight = (value, field) => {
    if (value < 0 || value > 100) return setFormError('Please enter value between 0 to 100');
    else setFormError('');
    let copyOfRatingWeight = { ...ratingWeight };
    copyOfRatingWeight[field] = Number(value);
    setRatingWeight(copyOfRatingWeight);
  };

  const saveRatingWeight = () => {
    if (Number(ratingWeight['reviews']) + Number(ratingWeight['tests']) + Number(ratingWeight['questionnaire']) !== 100)
      return setFormError('The sum should be 100');
    if (isSuperadmin) updateCandidateRatingWeight(id, { value: ratingWeight });
    else updateCandidateRatingWeight(id, { ratingWeight });
  };

  return (
    <OuterContainer>
      <ContainerHeading>Candidate Rating Weights</ContainerHeading>
      <RecruitmentStagesContainer>
        <IntegrationFieldLabel margin="15px 0 0 0">Reviews (%)</IntegrationFieldLabel>
        <TextInput
          type="number"
          isEditing={true}
          fullWidthOnMobile
          height="33px"
          width="50%"
          margin="5px 0 0 0"
          value={ratingWeight.reviews.toString()}
          onChange={(e) => updateRatingWeight(e.target.value, 'reviews')}
        />

        <IntegrationFieldLabel margin="15px 0 0 0">Tests (%)</IntegrationFieldLabel>
        <TextInput
          type="number"
          isEditing={true}
          fullWidthOnMobile
          height="33px"
          margin="5px 0 0 0"
          width="50%"
          value={ratingWeight.tests.toString()}
          onChange={(e) => updateRatingWeight(e.target.value, 'tests')}
        />

        <IntegrationFieldLabel margin="15px 0 0 0">Quick questions (%)</IntegrationFieldLabel>
        <TextInput
          type="number"
          isEditing={true}
          fullWidthOnMobile
          height="33px"
          margin={formError ? '5px 0 15px 0' : '5px 0 0 0'}
          width="50%"
          value={ratingWeight.questionnaire.toString()}
          onChange={(e) => updateRatingWeight(e.target.value, 'questionnaire')}
        />
        {formError && <ErrorMessage>{formError}</ErrorMessage>}
        <Button
          small
          primaryBlue
          primaryGreenBorder
          removeMargin
          margin="15px 0 0 0"
          onClick={() => saveRatingWeight()}
        >
          Save
        </Button>
      </RecruitmentStagesContainer>
    </OuterContainer>
  );
});
